const stripTrailingSlash = (value: string): string => value.replace(/\/+$/, "");

const configuredApiOrigin = stripTrailingSlash(String(import.meta.env.VITE_SPARE_CART_API ?? ""));

/**
 * Refresh token is an httpOnly cookie with SameSite=Lax on the auth path.
 * Cross-origin API calls (e.g. :3004 → :2307) do not send that cookie on POST,
 * so local dev must hit the API through the Vite proxy (relative `/api/v1`).
 */
const resolveApiOrigin = (): string => {
  if (configuredApiOrigin === "") return "";
  if (!import.meta.env.DEV || typeof window === "undefined") return configuredApiOrigin;

  try {
    const targetOrigin = new URL(configuredApiOrigin).origin;
    if (targetOrigin !== window.location.origin) return "";
  } catch {
    return configuredApiOrigin;
  }

  return configuredApiOrigin;
};

const apiOrigin = resolveApiOrigin();

export const env = {
  apiOrigin,
  apiBaseUrl: `${apiOrigin}/api/v1`,
} as const;
